import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import customFetchBase from '../expiredToken/expiredToken';
import {
  IApplicationItem,
  IApplicationLogResponse
} from '../../types/applications/ApplicationsInterfaces';

const customFetch = customFetchBase(config.baseUrlDealers);
const customFetchResidential = customFetchBase(config.baseUrlResidential);

export const apiApplications = createApi({
  baseQuery: customFetch,
  endpoints: (builder) => ({
    getApplicationsByLocation: builder.mutation<IApplicationItem[], number>({
      query: (locationId) => ({
        url: `api/Application/ByLocation/${locationId}`,
        method: 'GET'
      })
    }),
    getReleaseVersions: builder.mutation<
      { project: string; version: string; updatedAt: string }[],
      any
    >({
      query: () => ({
        url: `api/ReleaseVersion`,
        method: 'GET'
      })
    }),
    getMasterVersions: builder.mutation<
      { project: string; version: string; updatedAt: string },
      any
    >({
      query: () => ({
        url: `api/ReleaseVersion/master`,
        method: 'GET',
        keepUnusedDataFor: 60 * 60 * 24
      })
    })
  })
});

export const {
  useGetApplicationsByLocationMutation,
  useGetReleaseVersionsMutation,
  useGetMasterVersionsMutation
} = apiApplications;

export const apiApplicationsResidential = createApi({
  baseQuery: customFetchResidential,
  endpoints: (builder) => ({
    getGroupsByLocation: builder.mutation<IApplicationItem[], number>({
      query: (locationId) => ({
        url: `api/Group/AllGroupsByLocation/${locationId}`,
        method: 'GET'
      })
    }),
    getLogsByApplication: builder.mutation<
      IApplicationLogResponse,
      number | void
    >({
      query: (userId) => ({
        url: userId ? `api/Log/Application/${userId}` : 'api/Log/Application',
        method: 'GET'
      })
    })
  })
});

export const {
  useGetGroupsByLocationMutation,
  useGetLogsByApplicationMutation
} = apiApplicationsResidential;
